import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Toggler from 'modules/shift_management/components/ShiftManagement/Content/TableHeader/ShiftActionsBar/ViewOptionsSectionButton/Content/Toggler'
import { useCurrentViewOptions } from 'modules/shift_management/hooks/useCurrentViewOptions'
import { CoverageOptions } from 'modules/shift_management/store/internal/models/ViewOptions'

interface Props {
  onChange: (option: keyof CoverageOptions) => void
}

const CoverageOptionsContent = ({ onChange }: Props) => {
  const { viewOptions } = useCurrentViewOptions()
  const { coverage } = viewOptions
  const {
    showCompactView,
    showName,
    showWorkplace,
    showWorkArea,
    showOvertime,
    showBreaks,
    showNotes,
  } = coverage

  const disabled = showCompactView

  return (
    <>
      <Text color="grey700" size="50" weight="bold" caps>
        {i18n.t('shift_management.view_options.titles.coverage')}
      </Text>
      <Box gap="s8">
        <Toggler
          option="showCompactView"
          value={showCompactView}
          onChange={() => onChange('showCompactView')}
        />
        <Toggler
          option="showName"
          value={showName}
          disabled={disabled}
          onChange={() => onChange('showName')}
        />
        <Toggler
          option="showWorkplace"
          value={showWorkplace}
          disabled={disabled}
          onChange={() => onChange('showWorkplace')}
        />
        <Toggler
          option="showWorkArea"
          value={showWorkArea}
          disabled={disabled}
          onChange={() => onChange('showWorkArea')}
        />
        <Toggler
          option="showOvertime"
          value={showOvertime}
          disabled={disabled}
          onChange={() => onChange('showOvertime')}
        />
        <Toggler
          option="showBreaks"
          value={showBreaks}
          disabled={disabled}
          onChange={() => onChange('showBreaks')}
        />
        <Toggler
          option="showNotes"
          value={showNotes}
          disabled={disabled}
          onChange={() => onChange('showNotes')}
        />
      </Box>
    </>
  )
}

export default observer(CoverageOptionsContent)
